import {styled} from '@mui/system';
import theme from '../theme';

export const LogoContainer = styled('div')({
  height: '46px',
  borderWidth: '2px',
  borderBottomStyle: 'solid',
  borderColor: theme.colors.black,
});

export const LogoVerticalLine = styled('div')({
  height: '14px',
  width: '50%',
  borderRightStyle: 'solid',
  borderColor: theme.colors.black,
  borderWidth: '2px',
});
